import { $fsf } from "@2kog/pkg-common/utils/api.js";

// 指定日期合约统计
export function getContractStat(params) {
    return $fsf().get("/contract/stat", { params });
}

// 指定日期合约统计 - free
export function getContractStatFree(params) {
    return $fsf().get("/contract/stat/free", { params });
}

// 指定时间段合约统计
export function getContractStatList(params) {
    return $fsf().get("/contract/stat/list", { params });
}

// 获取期权新闻列表
export function getContractNews(params) {
    return $fsf().get("/contract/news", { params });
}

// 获取指数/标的列表数据
export function getContractStockIndex(params) {
    return $fsf().get("/contract/stock_index", { params });
}

// 获取指定日期指定标的的全部合约情况
export function getContractRecall(params) {
    return $fsf().get("/contract/recall", { params });
}

// 获取指定日期指定标的的全部合约情况
export function getContractRecallFree(params) {
    return $fsf().get("/contract/recall/free", { params });
}

// 获取上一个交易日的合约情况
export function getContractRecallPrev(params) {
    return $fsf().get("/contract/recall/last", { params });
}

// 获取单个合约
export function getContractItem(contract_code, params) {
    return $fsf().get(`/contract/recall/${contract_code}`, { params });
}

// 获取合约到期天数记录
export function getContractPromptDay(params) {
    return $fsf().get("/contract/promptday", { params });
}

export function getContractPromptDayFree(params) {
    return $fsf().get("/contract/promptday/free", { params });
}

/**
 * 获取指定日期/指定标的概况
 * @param {string} date YYYY-MM-DD required
 * @param {string} code 510050 required
 * @returns
 */
export function getContractUnderlying(params) {
    return $fsf().get("/contract/underlying", { params });
}

export function getContractUnderlyingFree(params) {
    return $fsf().get("/contract/underlying/free", { params });
}

/**
 * 获取指定条件的标的情况
 * @param {string} date YYYY-MM-DD
 * @param {string} code 510050
 * @returns
 */
export function getContractUnderlyingList(params) {
    return $fsf().get("/contract/underlying/list", { params });
}

/**
 * 获取指定日期/标的的风险情况
 * @param {string} date YYYY-MM-DD
 * @param {string} code 510050
 * @returns
 */
export function getContractRisk(params) {
    return $fsf().get("/contract/risk", { params });
}

/**
 * 创建期权计算推导
 * @param {Object} data
 * @returns
 */
export function createContractCalcStrategy(data) {
    return $fsf().post("/contract/calc_strategy", data);
}

/**
 * 删除
 * @param {string} strategy_id
 * @returns
 */
export function deleteContractCalcStrategy(strategy_id) {
    return $fsf().delete(`/contract/calc_strategy/${strategy_id}`);
}

/**
 * 更新
 * @param {string} strategy_id
 * @param {Object} data
 * @returns
 */
export function updateContractCalcStrategy(strategy_id, data) {
    return $fsf().put(`/contract/calc_strategy/${strategy_id}`, data);
}

/**
 * 获取期权计算推导列表
 * @param {Object} params
 * @returns
 */
export function getContractCalcStrategyList(params) {
    return $fsf().get("/contract/calc_strategy", { params });
}

/**
 * 获取单个期权计算推导
 * @param {string} strategy_id
 * @returns
 */
export function getContractCalcStrategyItem(strategy_id) {
    return $fsf().get(`/contract/calc_strategy/${strategy_id}`);
}

// iv
export function getUnderlyingIv(params) {
    return $fsf().get("/contract/underlying/iv", { params });
}
